import { faBuilding } from "@fortawesome/free-solid-svg-icons";
import React from "react";
import ComponentHeader from "../../UI/ComponentHeader";
import JobsiteInformationCard from "./JobsiteInformationCard";
import JobsitePPEInformationCard from "./JobsitePPEInformationCard";
import PortalAdditionalInformationCard from "./PortalAdditionalInformationCard";
import PortalFilesCard from "./PortalFilesCard";

interface JobsiteOverviewProps {
    showHeader?: boolean;
    project: any;
}
const JobsiteOverview: React.FC<JobsiteOverviewProps> = ({ showHeader, project }) => {
    if (!project) {
        return null;
    }
    return (
        <div className="flex flex-col gap-6">
            {showHeader && <ComponentHeader label="Jobsite Information" icon={faBuilding} color="text-blue-600" />}
            <JobsiteInformationCard project={project} />
            <JobsitePPEInformationCard project={project} />
            <PortalFilesCard project={project} />
            <PortalAdditionalInformationCard project={project} />
        </div>
    );
};

export default JobsiteOverview;
